import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { useMemo } from "react";

const useSubUserControl = () => {
  const { hasActiveSubUser, hasEverInvitedSubUser, hasEverHadActiveSubUser } =
    useRetailerStore([
      "hasActiveSubUser",
      "hasEverInvitedSubUser",
      "hasEverHadActiveSubUser",
    ]);

  return {
    hasActiveSubUser,
    hasEverInvitedSubUser,
    hasEverHadActiveSubUser,
  };
};

const useSubUserTreatment = () => {
  const { retailer } = useRetailer();

  const hasActiveSubUser = useMemo(
    () =>
      retailer?.multi_user_states?.includes(
        IRetailer.MultiUserState.HAS_ACTIVE_SUBUSER
      ),
    [retailer?.multi_user_states]
  );
  const hasEverInvitedSubUser = useMemo(
    () =>
      retailer?.multi_user_states?.includes(
        IRetailer.MultiUserState.HAS_INVITED_SUBUSER
      ),
    [retailer?.multi_user_states]
  );
  const hasEverHadActiveSubUser = useMemo(
    () =>
      retailer?.multi_user_states?.includes(
        IRetailer.MultiUserState.HAS_EVER_HAD_ACTIVE_SUB_USER
      ),
    [retailer?.multi_user_states]
  );

  return useMemo(
    () => ({
      hasActiveSubUser,
      hasEverInvitedSubUser,
      hasEverHadActiveSubUser,
    }),
    [hasActiveSubUser, hasEverInvitedSubUser, hasEverHadActiveSubUser]
  );
};

export const useSubUser = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSubUserTreatment();
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useSubUserControl();
};
